export const SESSION_STORAGE_KEY = 'web_app_session';
export const CPE_MODE_ROUTER = 'ROUTER';
export const CPE_MODE_PASSTHROUGH = 'PASSTHROUGH';
// L2 bridge between the circuit (WAN0) and the LAN, managed over cellular only.
export const CPE_MODE_PRIVATE_LINE = 'PRIVATE_LINE';
// Products with a modem; Private Line is offered only on these.
export const CELLULAR_PROD_CODES = ['BN-CPE-1000C', 'BN-CPE-1000FC', 'BN-CPE-10GFC'];
export const NECP_SESSION_ID = 'necp_session_id';
export const TIME_BUTTONS = [
  {
    label: '1h',
    value: { hours: 1 },
  },
  {
    label: '3h',
    value: { hours: 3 },
  },
  {
    label: '12h',
    value: { hours: 12 },
  },
  {
    label: '1d',
    value: { days: 1 },
  },
  {
    label: '3d',
    value: { days: 3 },
  },
  {
    label: '1w',
    value: { days: 7 },
  },
];
export const CELLULAR_TIME_BUTTONS = [
  {
    label: '1h',
    value: { hours: 1 },
  },
  {
    label: '3h',
    value: { hours: 3 },
  },
  {
    label: 'Day',
    value: { days: 1 },
  },
  {
    label: 'Week',
    value: { days: 7 },
  },
  {
    label: 'Month',
    value: { days: 30 },
  },
];
export const DASHBOARD_TIME_BUTTONS = [
  {
    label: '1h',
    value: { hours: 1 },
    tooltip: 'Last hour',
  },
  {
    label: '3h',
    value: { hours: 3 },
    tooltip: 'Last 3 hours',
  },
  {
    label: 'Day',
    value: { days: 1 },
    tooltip: 'Last day',
  },
  {
    label: 'Week',
    value: { days: 7 },
    tooltip: 'Last week',
  },
  {
    label: 'Month',
    value: { days: 30 },
    tooltip: 'Last month',
  }
];
